/**
 * Ads
 */

var component_content_ads = function(args) {

  function get_first_non_empty_sibling_upwards(el) {
    do {
      el = el.previousSibling;
    } while (el && el.nodeType !== 1);
    return el;
  }

  function get_nth_paragraph(el, nth) {
    var i = 1;
    do {
      el = el.nextSibling;
      if (el.nodeType == 1 && el.tagName == 'P') {
        i++;
      }
    } while (el && i < nth);
    if (i == nth) {
      return el;
    }
    return false;
  }

  /**
   * Move ads inside content
   */

  var banners_to_move = [];
  var ad      = document.querySelector('.js-content-ad');
  var content = document.querySelector('.js-wysiwyg');

  if (ad && content) {

    banners_to_move.push(ad);

    // move banners inside manually set places
    var manual_placeholders = document.querySelectorAll('.ad-block');
    for (var i = 0; i < manual_placeholders.length; i++) {
      if (banners_to_move.length > 0) {
        manual_placeholders[i].appendChild(banners_to_move.shift());
      }
    }

    var titles = content.querySelectorAll('h2');
    var contents = content.children;
    var autoplace, position;

    for (var j = 0; j < banners_to_move.length; j++) {

      // 1st banner
      if (j == 0) {
        if (1 in titles) {
          // before 2nd title if exists
          position = 'before';
          autoplace = get_first_non_empty_sibling_upwards(titles[1]);
        } else {
          // before 5th paragraph
          position = 'after';
          autoplace = get_nth_paragraph(contents[0], 5);
        }
      }

      // 2nd banner
      if (j == 1) {
        if (3 in titles) {
          // before 4th heading if exists
          position = 'before';
          autoplace = get_first_non_empty_sibling_upwards(titles[3]);
        } else {
          // before 12th paragraph
          position = 'after';
          autoplace = get_nth_paragraph(contents[0], 12);
        }
      }

      if (autoplace) {
        if (position == 'after') {
          autoplace.parentNode.insertBefore(banners_to_move[j], autoplace.nextSibling);
        } else {
          autoplace.parentNode.insertBefore(banners_to_move[j], autoplace);
        }
      }

    }

  }

  /**
   * Tracking: displays
   */

  function trigger_view_event(el) {

    if (!el) {
      return;
    }

    var is_already_tracked = el.classList.contains('js-ad-view-tracked');
    var code = el.getAttribute('data-tracking-code');

    if (!is_already_tracked) {

      if (typeof gtag === 'function') {

        gtag('event', 'view', {
          'event_category' : 'ads',
          'event_label' : code,
          'non_interaction': true
        });

        console.log('AD view: ' + code);

        el.classList.add('js-ad-view-tracked');

      }

    }


  }

  function in_view_handler(els, observer) {
    if (els.length) {
      for (var i = 0; i < els.length; i++) {
        if (els[i].isIntersecting) {
          trigger_view_event(els[i].target);
        }
      }
    }
  }

  function click_handler(e) {

    var el = e.currentTarget;
    var code = el.getAttribute('data-tracking-code');

    if (!el.classList.contains('js-ad-click-tracked')) {

      if (typeof gtag === 'function') {

        gtag('event', 'click', {
          'event_category' : 'ads',
          'event_label' : code
        });

        console.log('AD click: ' + code);

        el.classList.add('js-ad-click-tracked');

      }

    }

  }

  var trackable_ads = document.querySelectorAll('.js-ad-tracking');
  if (trackable_ads.length) {
    for (var j = 0; j < trackable_ads.length; j++) {

      // view counter
      if(!!window.IntersectionObserver) {
        var observer = new IntersectionObserver(in_view_handler);
        observer.observe(trackable_ads[j]);
      } else {
        trigger_view_event(trackable_ads[j]);
      }

      // click counter
      trackable_ads[j].addEventListener('click', click_handler);

    }
  }





  // make the call chainable
  return this;

};
